
export default {
    name: 'PaginationPager',
    props: {
        /**
         * A Pagination object
         */
        pagination: {
            type: Object,
            required: true,
        },
        /**
         * The current Vue route
         */
        route: {
            type: Object,
            required: true,
        },
    },
    methods: {
        clickHandler() {
            this.$nextTick(() => {
                window.scrollTo(0, 0);
            });
        },
        pageRoute(page) {
            const route = { ...this.route, query: { ...this.route.query } };
            if (page <= 1) {
                delete route.query.page;
                return route;
            }

            route.query.page = page;
            return route;
        },
    },
};

